import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommDriverErrorList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCError: DataSource;
    tableMCError: Table;
}
